import classNames from 'classnames';

import styles from './_index.module.scss';

const PopoverMenu = ({ className, ...props }: React.HTMLProps<HTMLDivElement>) => {
  return <div className={classNames(styles['popover-menu'], className)} {...props} />;
};

export default PopoverMenu;
